module.exports = __webpack_public_path__ + "static/media/nodatalist.5a55bb18.png";